import * as React from "react";

import { Authorize } from "reauthorize";
import { Button } from "semantic-ui-react";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";

import { connect } from "react-redux";
import { isRequestActive } from "redux-request-loading";

import { ADMIN_ROLES } from "../../../../auth";
import { ApplicationState } from "../../../../applicationState";
import { createCustomerDataExtract } from "../../../../dataExtracts/actions";
import { CREATE_CUSTOMER_DATA_EXTRACT } from "../../../../dataExtracts/actionTypes";

import { CoreDetailProps } from "../Detail";

import ActivateButton from "./ActivateButton";
import DeactivateButton from "./DeactivateButton";

import { push } from "redux-little-router";

interface CoreDetailsButtonsStateProps {
    isCreatingDataExtract: boolean;
}

interface CoreDetailsButtonsDispatchProps {
    createDataExtract(customerId: string): Promise<void>;
    navigateToDataExtracts(): void;
}

class CoreDetailsButtonsUnconnected extends React.Component<CoreDetailProps & CoreDetailsButtonsStateProps & CoreDetailsButtonsDispatchProps> {
    constructor(props: CoreDetailProps & CoreDetailsButtonsStateProps & CoreDetailsButtonsDispatchProps) {
        super(props);
        this.downloadData = this.downloadData.bind(this);
    }

    public render() {
        const activeDeactiveButton = this.props.customer.active ? (<DeactivateButton />) : (<ActivateButton />);
        return (
            <>
                {activeDeactiveButton}
                <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                    <Button
                        icon="download"
                        content="Download Data"
                        onClick={this.downloadData}
                        loading={this.props.isCreatingDataExtract}
                        disabled={this.props.isCreatingDataExtract}
                        secondary
                    />
                </Authorize>
            </>
        );
    }

    private async downloadData() {
        await this.props.createDataExtract(this.props.customer.id);
        this.props.navigateToDataExtracts();
    }
}

const mapStateToProps = (state: ApplicationState): CoreDetailsButtonsStateProps => ({
    isCreatingDataExtract: isRequestActive(state, CREATE_CUSTOMER_DATA_EXTRACT)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, Action>): CoreDetailsButtonsDispatchProps => ({
    createDataExtract: (customerId: string) => dispatch(createCustomerDataExtract(customerId)),
    navigateToDataExtracts: () => dispatch(push("/dataExtracts"))
});

export const CoreDetailsButtons = connect(mapStateToProps, mapDispatchToProps)(CoreDetailsButtonsUnconnected);
